// extracted by mini-css-extract-plugin
module.exports = {"root":"Notification_root__Fyj4N","message":"Notification_message__BYadA"};